import { Liquid } from "liquidjs";

import customFilters from "./filters";
import operators from "./operators";

// We implement an allowlist of allowed filters and tags. Liquidjs only
// implement a way to remove tags and filters, so we diff our allowlist against
// the default list of tags and filters.
export const ALLOWED_TAGS = [
  "assign",
  "capture",
  "comment",
  "if",
  "raw",
  "unless",
  "#",
];

export const ALLOWED_FILTERS = [
  "abs",
  "append",
  "at_least",
  "at_most",
  "capitalize",
  "ceil",
  "default",
  "divided_by",
  "downcase",
  "floor",
  "lstrip",
  "minus",
  "modulo",
  "plus",
  "prepend",
  "remove",
  "remove_first",
  "remove_last",
  "replace",
  "replace_first",
  "replace_last",
  "reverse",
  "round",
  "rstrip",
  "size",
  "slice",
  "strip",
  "strip_html",
  "strip_newlines",
  "times",
  "truncate",
  "truncatewords",
  "upcase",
  "url_decode",
  "url_encode",
  ...Object.keys(customFilters),
];

const disabledTag = {
  parse: function (token: any) {
    throw new Error(`tag "${token.name}" disabled`);
  },
  render: function () {
    throw new Error("tag disabled");
  },
};

function disabledFilter(name: string) {
  return function () {
    throw new Error(`filter "${name}" disabled`);
  };
}

export function constructEngine(): Liquid {
  const engine = new Liquid({
    strictFilters: true,
    operators,
  });

  // LiquidJS doesn't allow "unregistering" tags/filters per se, but they
  // recommend this approach: https://liquidjs.com/tutorials/register-filters-tags.html#Unregister-Tags-Filters
  Object.keys(engine.tags).forEach(tag => {
    if (!ALLOWED_TAGS.includes(tag)) {
      engine.registerTag(tag, disabledTag);
    }
  });

  Object.keys(engine.filters).forEach(filter => {
    if (!ALLOWED_FILTERS.includes(filter)) {
      engine.registerFilter(filter, disabledFilter(filter));
    }
  });

  for (const [key, value] of Object.entries(customFilters)) {
    engine.registerFilter(key, value);
  }

  return engine;
}

export default constructEngine();
